import { startCheckout } from '../utils/checkout';
import { SUPPORT_EMAIL } from '../utils/constants';

const included = [
  'The full desktop app for Windows & macOS — use it on up to 3 devices',
  'Your coordinating, scheduled Claude agent team',
  'Live meeting capture with voiceprint speaker ID',
  'Every future update — free, forever',
];

const Pricing = () => {
  const buy = () => startCheckout('pricing');

  return (
    <section className="pricing" id="pricing">
      <div className="pricing-glow" aria-hidden="true" />
      <div className="section-container pricing-inner">
        <p className="overline overline--center">PRICING</p>
        <h2 className="section-title">Buy once. Own it forever.</h2>
        <p className="section-subtitle">
          One purchase, lifetime use. No subscription required, no per-seat fees.
          You bring your own keys — so you only ever pay your own providers for what you use.
        </p>

        <div className="pricing-card">
          <div className="pricing-price">
            <span className="pricing-old mono">$50</span>
            <span className="pricing-new">$25</span>
            <span className="pricing-badge mono">LAUNCH PRICING</span>
          </div>
          <p className="pricing-tagline">
            One-time payment. $25 while we launch — $50 after. Yours for life either way.
          </p>

          <ul className="pricing-included">
            {included.map((item, i) => (
              <li key={i}>
                <span className="pricing-check" aria-hidden="true">
                  ✓
                </span>
                {item}
              </li>
            ))}
          </ul>

          <button className="btn btn-primary pricing-buy" onClick={buy}>
            Buy now — $25 →
          </button>

          <p className="pricing-guarantee mono">
            7-day money-back guarantee — one email to {SUPPORT_EMAIL} · No subscription required
            · One purchase, lifetime use
          </p>
        </div>

        <div className="pricing-addon">
          <div className="pricing-addon-head">
            <span className="pricing-addon-badge mono">OPTIONAL ADD-ON</span>
            <h3>
              Solidly Sync <span className="pricing-addon-price">$5/mo</span>
            </h3>
          </div>
          <p>
            Encrypted cloud backup &amp; multi-device sync. Move your whole team of agents to a
            new machine in minutes, and designate a primary device that runs your schedules so a
            job never fires twice. Completely optional — the app is fully yours without it.
          </p>
        </div>

        <div className="pricing-byo">
          <p className="pricing-byo-title">What you bring</p>
          <div className="pricing-byo-grid">
            <div className="pricing-byo-item">
              <span className="pricing-byo-num mono">01</span>
              <h4>Your Claude subscription</h4>
              <p>
                Agents run on top of your existing Claude plan, on your machine. We don't resell
                Claude or mark it up.
              </p>
            </div>
            <div className="pricing-byo-item">
              <span className="pricing-byo-num mono">02</span>
              <h4>Your transcription key</h4>
              <p>
                Meetings are transcribed through your own provider key — you pay your provider
                directly for exactly what you transcribe, nothing through us.
              </p>
            </div>
          </div>
          <p className="pricing-byo-note">
            Solidly doesn't resell your providers or mark them up. Your keys, your accounts,
            your usage.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
